import styled from "styled-components";
import { colors, font, radius, shadow } from "../../styles/theme/tokens";

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: #16132B;
  font-family: ${font.text};
`;

export const Viewport = styled.div`
  position: relative;
  flex: 1;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

// Сцена масштабується від центру; розмір 1280×720 задається інлайном
export const Stage = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -360px 0 0 -640px;
  transform-origin: center center;
  border-radius: 18px;
  overflow: hidden;
  background: ${colors.bg};
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.45);
`;

export const Message = styled.p`
  display: grid;
  place-items: center;
  height: 100vh;
  font-family: ${font.text};
  font-size: 18px;
  font-weight: 600;
  color: ${colors.muted};
`;

export const Controls = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  color: #FFFFFF;
`;

export const Lesson = styled.span`
  font-size: 14px;
  font-weight: 700;
  opacity: 0.7;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Nav = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const IconButton = styled.button`
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: #FFFFFF;
  background: rgba(255, 255, 255, 0.12);
  cursor: pointer;

  &:disabled {
    opacity: 0.3;
    cursor: default;
  }
`;

export const Counter = styled.button`
  min-width: 80px;
  padding: 8px 12px;
  border-radius: ${radius.pill};
  font-family: ${font.text};
  font-size: 15px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  color: #FFFFFF;
  background: rgba(255, 255, 255, 0.08);
  cursor: pointer;
`;

export const Tools = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 6px;
`;

export const Tool = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border-radius: ${radius.sm};
  font-family: ${font.text};
  font-size: 14px;
  font-weight: 700;
  color: #FFFFFF;
  background: ${(props) => (props.$active ? colors.brand : "rgba(255, 255, 255, 0.1)")};
  cursor: pointer;

  &:disabled {
    opacity: 0.3;
    cursor: default;
  }
`;

export const Note = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 16px;
  padding: 10px 14px;
  border-radius: ${radius.md};
  font-size: 15px;
  font-weight: 600;
  color: ${colors.ink};
  background: ${colors.amberSoft};
`;

export const Grid = styled.div`
  position: fixed;
  inset: 0;
  z-index: 50;
  display: grid;
  place-items: center;
  padding: 24px;
  background: rgba(10, 8, 25, 0.75);
`;

export const GridInner = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 12px;
  width: min(1100px, 100%);
  max-height: 85vh;
  overflow-y: auto;
  padding: 20px;
  border-radius: ${radius.xl};
  background: ${colors.surface};
  box-shadow: ${shadow.raised};
`;

export const GridItem = styled.button`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  padding: 12px 14px;
  border-radius: ${radius.md};
  text-align: left;
  font-family: ${font.text};
  color: ${colors.ink};
  background: ${(props) => (props.$current ? colors.brandSoft : colors.bg)};
  border: 2px solid ${(props) => (props.$current ? colors.brand : "transparent")};
  cursor: pointer;

  span {
    font-size: 13px;
    font-weight: 800;
    color: ${colors.brandDeep};
  }

  small {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: ${colors.muted};
  }

  b {
    font-size: 15px;
    font-weight: 800;
  }
`;
